export const HOSTNAME = {
    localhost: 'localhost',
    int: 'admin-user-access.aws.int.test.visma.net',
    stag: 'admin-user-access.stag.visma.net',
    prod: 'admin-user-access.visma.net'
}
